
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Eine schlechte Nachricht für alle Facebook-Fans: Forscher der Universität in Pittsburgh haben knapp 2000 Jugendliche im Alter zwischen 19 und 32 Jahren nach ihrem Internetverhalten befragt – und die Daten mit ihren Schlafgewohnheiten verglichen. `}<M mdxType="M">{`Diejenigen Probanden, die besonders häufig auf Social Media-Plattformen unterwegs waren, litten häufiger unter Schlafproblemen als Internetmuffel.`}</M><br /><br />{`
Die Mediziner vermuten, dass Menschen häufig abends entgegen ihrem Schlafbedürfnis wach bleiben und auf Twitter und Instagram surfen. Der Schlafrhythmus könnte dadurch verschoben werden, emotionale Erlebnisse wie wilde Facebook-Diskussionen fordern zudem das Gehirn. Allerdings ist bislang unklar, ob dieser Zusammenhang wirklich stimmt. Es könnte auch sein, dass Menschen nicht einschlafen können und sich deshalb mit Facebook und Twitter ablenken.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;